import { db } from "./firebase";
import { ref, onValue } from "firebase/database";
import { useState, useEffect } from "react";

const GetProjects = () => {
  const [projects, setProjects] = useState([]);
  const [isPending, setIsPending] = useState(true);

  //read
  useEffect(() => {
    setTimeout(() => {
      onValue(ref(db), (snapshot) => {
        setProjects([]);
        const data = snapshot.val();
        if (data !== null) {
          Object.values(data).map((project) => {
            setProjects((oldArray) => [...oldArray, project]);
          });
          setIsPending(false);
        }
      });
    }, 0);
  }, []);
  return { projects, isPending };
};

export default GetProjects;
